import React from 'react';
import ClickableElement from 'src/components/ClickableElement';

import icon from './mobile_share.svg';
import { FormattedMessage } from 'react-intl';
import WhatsAppShare from 'src/components/SocialShare/WhatsAppShare';
import { ShareActionOptions } from 'src/redux/modules/page';
import FacebookShare from 'src/components/FacebookShare/FacebookShare';

interface Props {
  closeModal: () => void;
  ownerName: string;
  shareByWhatsApp: (options: ShareActionOptions) => void;
  socialShareUrl: string;
  targetAmount: number;
  pitchFor: string;
  targetCurrency: Currency;
  dualShareTest: boolean;
}

class MobileEncourageShare extends React.Component<Props> {
  render() {
    const {
      ownerName,
      closeModal,
      shareByWhatsApp,
      socialShareUrl,
      targetAmount,
      pitchFor,
      targetCurrency,
      dualShareTest,
    } = this.props;
    return (
      <div
        className="row jg-space-phsm jg-space-ptlg jg-display-flex jg-flex-aic"
        style={{ height: '100vh' }}
      >
        <div className="col-md-12 jg-text--center">
          <img
            src={icon}
            alt="People sharing the page via Whatsapp"
            className="jg-space-mbmd"
          />

          <h1>
            <FormattedMessage
              id="DesktopEncourageShare.title"
              defaultMessage="Sharing with friends is&nbsp;powerful"
            />
          </h1>

          <p className="jg-space-mbml">
            <FormattedMessage
              id="DesktopEncourageShare.didYouKnow"
              defaultMessage="Sharing this page with your friends could help {ownerName} get over £100* in donations."
              values={{
                ownerName,
              }}
            />
          </p>

          {!dualShareTest && (
            <FacebookShare
              buttonText="Share to Facebook"
              location="page > share prompt"
              className="jg-space-mbmd"
            />
          )}

          {dualShareTest && (
            <div className="row">
              <div className="col-sm-6">
                <FacebookShare
                  buttonText="Share"
                  location="page > share prompt"
                  className="jg-space-mbmd"
                />
              </div>

              <div className="col-sm-6">
                <WhatsAppShare
                  shareByWhatsApp={shareByWhatsApp}
                  socialShareUrl={socialShareUrl}
                  targetAmount={targetAmount}
                  pitchFor={pitchFor}
                  ownerName={ownerName}
                  isOwner={false}
                  isActive
                  targetCurrency={targetCurrency}
                  location="page > share prompt"
                  className="jg-space-mbml jg-btn jg-btn--whatsapp"
                  buttonText={
                    <FormattedMessage
                      id="DesktopEncourageShare.whatsappButton"
                      defaultMessage="Share"
                    />
                  }
                />
              </div>
            </div>
          )}

          <ClickableElement
            id="skip-share-prompt"
            onClick={closeModal}
            className="jg-text--link jg-text--center jg-space-mbml"
          >
            <FormattedMessage
              id="DesktopEncourageShare.maybeLater"
              defaultMessage="Not now, maybe later."
            />
          </ClickableElement>

          <p className="jg-text--xsmall-light jg-text--center">
            <FormattedMessage
              id="DesktopEncourageShare.basedOn"
              defaultMessage="*Based on JustGiving data as of 2018"
            />
          </p>
        </div>
      </div>
    );
  }
}

export default MobileEncourageShare;



// WEBPACK FOOTER //
// ./src/components/Page/EncourageShare/MobileEncourageShare.tsx